module.exports = __webpack_public_path__ + "img/7.917583d9.jpg";